// extracted by mini-css-extract-plugin
export default {"card":"polaroid_card__FvVSi","picture":"polaroid_picture__vhpNS","caption":"polaroid_caption__94ZWh"};